import Big from 'big.js';

/*
 * Built supports rounding to 14 decimal places
 * ref: https://getbuilt.atlassian.net/wiki/x/ZoCpGQ
 */
Big.DP = 14;
/*
 * Implements ROUND_DOWN, which essentially truncates
 * The services implement ROUND_HALF_EVEN, but since we use toFixed(2) here (which rounds), we have to round down / truncate to stay consistent when summing
 */
Big.RM = 0;
function getNumber(value) {
    const isExpForm = /^([+-])?(\d+)\.?(\d*)[eE]([+-]?\d+)$/;
    let v = typeof value === 'function' ? value() : value;
    if (!v)
        return 0;
    if (isExpForm.test(v)) {
        return Number(v);
    }
    // remove all but first '-'
    v = v.toString().replace(/(?!^)-/g, '');
    // remove everything else
    v = v.replace(/[^(\-|0-9|.)]/g, '');
    if (v === null) {
        return 0;
    }
    if (isNaN(v)) {
        return 0;
    }
    else {
        return Number(v);
    }
}
/**
 * Round a given number value to a number of decimal places with extreme precision
 *
 * @param {number} value the number to round
 * @param {number} decimals the number of decimal places to which to round
 */
function round(valueValue, decimals) {
    const value = getNumber(valueValue);
    return Big(value || 0)
        .round(decimals || 0)
        .toString();
}
function addMoney(...addends) {
    let total = Big(0);
    addends.forEach((addend) => {
        total = total.plus(getNumber(addend || 0));
    });
    return total.toFixed(2);
}
function addMoneyAsNumber(...addends) {
    return Number(addMoney(...addends));
}
function subtractMoney(minuend, ...subtrahends) {
    let total = Big(getNumber(minuend || 0));
    subtrahends.forEach((subtrahend) => {
        total = total.minus(getNumber(subtrahend || 0));
    });
    return total.toFixed(2);
}
function subtractMoneyAsNumber(minuend, ...subtrahends) {
    return Number(subtractMoney(minuend, ...subtrahends));
}
function multiplyMoney(multiplicandValue, multiplierValue) {
    const multiplicand = getNumber(multiplicandValue);
    const multiplier = getNumber(multiplierValue);
    return Big(multiplicand || 0)
        .times(multiplier || 0)
        .toFixed(2);
}
function multiplyMoneyAsNumber(multiplicandValue, multiplierValue) {
    return Number(multiplyMoney(multiplicandValue, multiplierValue));
}
function divideMoney(dividendValue, divisorValue) {
    try {
        const dividend = getNumber(dividendValue);
        const divisor = getNumber(divisorValue);
        return Big(dividend || 0)
            .div(divisor || 0)
            .toFixed(2);
    }
    catch (e) {
        // Returns undefined for divide by zero errors
        return undefined;
    }
}
function divideMoneyAsNumber(dividendValue, divisorValue) {
    try {
        const dividend = getNumber(dividendValue);
        const divisor = getNumber(divisorValue);
        const val = Big(dividend || 0).div(divisor || 0);
        return Number(val);
    }
    catch (e) {
        // Returns undefined for divide by zero errors
        return undefined;
    }
}

export { addMoney, addMoneyAsNumber, divideMoney, divideMoneyAsNumber, getNumber, multiplyMoney, multiplyMoneyAsNumber, round, subtractMoney, subtractMoneyAsNumber };
//# sourceMappingURL=calculators.js.map
